'use strict';

// Converted from CoffeeScript to JavaScript - ETNA Authenticator Identity Menu Directives
intra_module.directive("identityItem", function() {
    return {
        restrict: "E",
        template: "<li ng-transclude></li>",
        transclude: true,
        replace: true
    };
});

intra_module.controller("identityMenuCtrl", ['$scope', 'loginModal', 'identity', function($scope, loginModal, identity) {
    $scope.me = identity;
    
    $scope.isADM = function() {
        if (identity.groups == null) {
            return false;
        }
        return identity.groups.indexOf("adm") !== -1;
    };
    
    $scope.logas = function() {
        return loginModal.open("logas");
    };
}]);

intra_module.directive("identityMenu", ['$compile', '$templateCache', function($compile, $templateCache) {
    return {
        restrict: "E",
        templateUrl: "partials/authenticator/identity-menu-template.html",
        transclude: true,
        replace: true,
        scope: {
            navbar: "=?"
        },
        controller: "identityMenuCtrl",
        link: function(scope, element, attrs) {
            var baseMenuItems = $templateCache.get("partials/authenticator/base-menu-items.html");
            if (baseMenuItems) {
                baseMenuItems = $compile(baseMenuItems)(scope);
                element.find("ul").append(baseMenuItems);
            }
        }
    };
}]);
